import {
  actions,
  ClearButtonBehaviour,
  DateInput,
  InputButton,
  KeyMap,
} from '@infotech-soe/erp-ui-kit';
import React, { useMemo } from 'react';

import { DictDateFormControlViewModel } from '../../../services/form/view-model/FormControlViewModel';

import { TFormControlConnectorProps } from './FormControlContainer';
import FormLabeledInputControl from './FormLabeledInputControl';
import { useDictionaryControl } from './useDictionaryControl';

type Props = TFormControlConnectorProps & {
  control: DictDateFormControlViewModel;
};

const FormDictDateControl = (props: Props) => {
  const { areHintsShown, control, onChange, onChanged, onSubmit } = props;
  const onButtonClick = useDictionaryControl(props);

  const keymap = useMemo(
    () => ({ [KeyMap[actions.CONTROL_POPUP]]: onButtonClick }),
    [onButtonClick]
  );

  return (
    <FormLabeledInputControl areHintsShown={areHintsShown} control={control}>
      <DateInput
        keymap={keymap}
        canClearOnReadOnly={control.canClearOnReadOnly}
        delimiter={control.delimiter}
        disabled={control.disabled}
        enableButtonOnReadOnly={control.enableButtonOnReadOnly}
        format={control.format}
        invalid={control.invalid}
        name={control.name}
        readOnly={control.readonly}
        required={control.required}
        truncTo={control.truncTo}
        value={control.value}
        withClearButton={ClearButtonBehaviour.NONE}
        onChange={onChange}
        onChanged={onChanged}
        onSubmit={onSubmit}
        endSlot={
          <InputButton
            {...{
              label: undefined,
              icon: 'ellipsis',
              onMouseDown: (e: React.MouseEvent) => e.preventDefault(),
              onClick: onButtonClick,
              disabled:
                control.disabled ||
                (control.readonly && !control.enableButtonOnReadOnly),
            }}
          />
        }
      />
    </FormLabeledInputControl>
  );
};

export default FormDictDateControl;
